/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './permissions';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "CredentialState": {
            "values": {
              "NONE": 0,
              "REQUIRED": 1,
              "OPTIONAL": 2
            }
          },
          "Permissions": {
            "fields": {
              "value": {
                "type": ".squareup.multipass.RequestPermissionFlags",
                "id": 1,
                "rule": "repeated"
              },
              "alternative": {
                "type": ".squareup.multipass.PermissionSet",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "PermissionSet": {
            "fields": {
              "value": {
                "type": ".squareup.multipass.RequestPermissionFlags",
                "id": 1,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.CredentialState && !$root.nested?.squareup?.nested?.multipass?.nested?.Permissions && !$root.nested?.squareup?.nested?.multipass?.nested?.PermissionSet) {
  $root.addJSON(jsonData);
}

/**
 * A tri-state flag indicating whether a method requires/accepts credentials.
 *
 * SOURCE CredentialState @ squareup/multipass/options.proto at 15:1
 */
export const CredentialState = $root.lookupEnum('squareup.multipass.CredentialState').values;
/**
 * RPC method option specifying the permissions required to access the method.
 *
 * SOURCE Permissions @ squareup/multipass/options.proto at 37:1
 */
export const Permissions = $root.lookupType('squareup.multipass.Permissions');
fixType(Permissions);
Builder.createAndAttachToType(Permissions);
/**
 * A single alternative.
 *
 * SOURCE PermissionSet @ squareup/multipass/options.proto at 66:1
 */
export const PermissionSet = $root.lookupType('squareup.multipass.PermissionSet');
fixType(PermissionSet);
Builder.createAndAttachToType(PermissionSet);